import EntityTile from '@sly/frontend/react/card';
import { arrayOf } from 'prop-types';
import React from 'react';
import reviewsPropType from 'sly/propTypes/review';
import EntityReview from 'sly/review/components/entity/EntityReview';

const EntityReviewsWithCommunityCard = ({ reviews }) => {
  return (
    <div data-tp-id='gen-div-2b4cebee-bad3-4b65-a8f8-ca71e1de5d90'>
      {!!reviews.length &&
        reviews.map((review, i) => {
          const { searchResource } = review;
          return (
            <React.Fragment key={review.id}>
              <EntityReview {...review} />
              {searchResource && (
                <EntityTile
                  className='!my-4 border-none !p-0'
                  entity={searchResource}
                  intent='search'
                />
              )}
              {i < reviews.length - 1 && <hr className='my-xl' />}
            </React.Fragment>
          );
        })}
    </div>
  );
};

EntityReviewsWithCommunityCard.propTypes = {
  reviews: arrayOf(reviewsPropType),
};

EntityReviewsWithCommunityCard.defaultProps = {
  reviews: [],
};

export default EntityReviewsWithCommunityCard;
